import {createAction, props} from "@ngrx/store";

export const loggingOut = createAction('[AUTH] Logging out');
export const logOut = createAction('[AUTH] Logout');
export const logOutFailed = createAction('[AUTH] Logout failed');

export const authenticatingCheck = createAction('[AUTH] Checking tokens');
export const authenticatingStart = createAction('[AUTH] Authenticating');
export const authenticatingEnd = createAction('[AUTH] Authenticating Successfull', props<{token: string; refreshToken: string; forceRedirect: boolean}>());
export const authenticatingRefreshTokenEnd = createAction('[AUTH] Refresh token end', props<{token: string; refreshToken: string;}>());
export const authenticatingCheckFailed = createAction('[AUTH] Checking tokens failed');
